import { Component, inject } from '@angular/core';
import { InternalMenuService } from '../../internal-menu-service';
import { ButtonModule } from 'primeng/button';
import { MatIcon } from '../mat-icon/mat-icon';

@Component({
  selector: 'app-internal-menu-button',
  imports: [ButtonModule, MatIcon],
  templateUrl: './internal-menu-button.html',
  styleUrl: './internal-menu-button.scss',
})
export class InternalMenuButton {
  private internalMenuService = inject(InternalMenuService);

  constructor() {}

  toggleMenu() {
    this.internalMenuService.toggleMenu();
  }
}
